import { render, staticRenderFns } from "./RemoveForm.vue?vue&type=template&id=a842374c&"
import script from "./RemoveForm.vue?vue&type=script&lang=js&"
export * from "./RemoveForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports